<template>
    <div class="digital-agency-assistance-area  section-space--ptb_120" id="about">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="digital-agency-section-title text-center section-space--mb_60">
						<h2 class="section-title mb-30 wow move-up">About Whaleio</h2>
                        <h5 class="section-title font-weight--light mb-15 wow move-up">Whaleio is a small nontraditional technology company growing in the Huntsville area. We provide purpose-built software applications for web, edge computing, embedded devices, and artificial intelligence in integrated hardware applications for commercial and government industry customers. </h5>
						<h4 class="section-sub-title section-sub-title--big mb-20 font-weight--bold wow move-up">Capabilities</h4>
                    </div>
                </div>
            </div>

            <!-- service agency component -->
			<WhaleioCapabilities/>
        </div>
    </div>
</template>

<script>
	import WhaleioCapabilities from '../WhaleioCapabilities'
    export default{
        name: 'ServiceAgency',
        components: {
			WhaleioCapabilities
        }
    };
</script>

<style lang="scss">
.section-sub-title--big{
	margin-top:80px;
	font-size:1.8rem !important; 
}
</style>